import { render, staticRenderFns } from "./monthlyReportUnitRecord.vue?vue&type=template&id=a28b0b12&scoped=true"
import script from "./monthlyReportUnitRecord.vue?vue&type=script&lang=js"
export * from "./monthlyReportUnitRecord.vue?vue&type=script&lang=js"
import style0 from "./monthlyReportUnitRecord.vue?vue&type=style&index=0&id=a28b0b12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28b0b12",
  null
  
)

export default component.exports